import React from 'react';
import { useNavigate } from 'react-router-dom';
import DownloadButton from '../download-button/download-button';
import { BUTTON_TYPES } from '../../constants/button-variants';
import { world } from '../../languages';
import { AVAILABLE_WORLDS } from '../../languages/constants';
import downloading from '../../utils/downloading';
import isInteractiveStandaloneMaterial from '../../utils/interactive/is-interactive-standalone-material';
import getFreeMaterial from '../../utils/material/download-free-material';
import navigateFreeThankYou from '../../utils/material/navigate-free-thank-you';

type GetFreePropsType = { item: Material; e?: Event; qualityEventsExtra?: string; disableScrollToTop?: boolean };

const getMaterialForFree = async ({ item, e, qualityEventsExtra, disableScrollToTop }: GetFreePropsType) => {
    // @ts-ignore
    Boolean(e) && downloading(e.currentTarget, item.id);

    await getFreeMaterial(item.id, { materialInfo: item }, qualityEventsExtra);

    !disableScrollToTop && window.scrollTo(0, 0);
};

type DownloadControlsProps = {
    material: Material;
    qualityEventsExtra?: string;
    disableScrollToTop?: boolean;
    type?: BUTTON_TYPES;
};

const DownloadControls = (props: DownloadControlsProps) => {
    const { material, qualityEventsExtra, disableScrollToTop, type } = props;
    const navigate = useNavigate();

    const onFreeDownload = async (e?: Event) => {
        if (!isInteractiveStandaloneMaterial(material) && world === AVAILABLE_WORLDS.DE) {
            navigateFreeThankYou({ navigate, materialId: material.id });
        } else {
            getMaterialForFree({ item: material, e, qualityEventsExtra, disableScrollToTop });
        }
    };

    const isMaterialFree = material.isFree || material.hasAclFree;

    return (
        <DownloadButton
            type={type}
            materialId={material.id}
            aclId={material.aclId}
            downloadStatus={isMaterialFree ? 'free' : (material.aclType as string)}
            onDownload={isMaterialFree ? onFreeDownload : undefined}
        />
    );
};

export default DownloadControls;
